import React from "react";
import ProductCard from "./ProductCard";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const SliderProducts = ({ selectedProducts }) => {
  const [lightbox, setLightbox] = React.useState({
    isOpen: false,
    image: "",
    index: 0,
  });

  const updateIndex = (action) => {
    const le = lightbox.prod.fotos.length;
    switch (action) {
      case "increment":
        setLightbox((li) => ({
          ...li,
          index: (li.index + le + 1) % le,
        }));
        break;

      case "decrement":
        setLightbox((li) => ({
          ...li,
          index: (li.index + le - 1) % le,
        }));
      default:
        break;
    }
  };

  const settings = {
    dots: true,
    arrows: true,
    infinite: false,
    centerMode: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider {...settings} className="list-produtos">
        {selectedProducts.map((item) => (
          <ProductCard
            key={item.id}
            onClick={() =>
              setLightbox({
                ...lightbox,
                isOpen: true,
                image: item.imageFull,
                prod: item,
              })
            }
            product={item}
          />
        ))}
      </Slider>
      {lightbox.isOpen && (
        <Lightbox
          mainSrc={lightbox.prod.fotos[lightbox.index] || lightbox.image}
          onCloseRequest={() =>
            setLightbox({ isOpen: false, image: "", index: 0 })
          }
          nextSrc={
            lightbox.prod.fotos[
              (lightbox.index + lightbox.prod.fotos.length + 1) %
                lightbox.prod.fotos.length
            ]
          }
          prevSrc={
            lightbox.prod.fotos[
              (lightbox.index + lightbox.prod.fotos.length - 1) %
                lightbox.prod.fotos.length
            ]
          }
          onMovePrevRequest={() => updateIndex("decrement")}
          onMoveNextRequest={() => updateIndex("increment")}
        />
      )}
    </>
  );
};

export default SliderProducts;
